export const auth_user_role_enum = [
  'MANAGER',
  'DEVELOPER',
  'DESIGNER',
  'VIEWER',
];
